import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useLanguage } from '../context/LanguageContext';

const { FiShield, FiHeart } = FiIcons;

const Visie = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen py-24 lg:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-6xl font-black text-brand-dark mb-20 text-center italic uppercase tracking-tighter leading-none">
          {t.vision.title}
        </h1>
        
        <div className="space-y-16">
          <div className="bg-white p-16 rounded-[3rem] shadow-2xl border border-gray-100 relative overflow-hidden group">
            <div className="absolute top-0 right-0 p-12 opacity-[0.03] group-hover:opacity-[0.08] transition-opacity">
              <SafeIcon icon={FiShield} className="w-48 h-48" />
            </div>
            <div className="flex items-center gap-6 mb-10">
              <div className="w-16 h-16 bg-orange-50 rounded-2xl flex items-center justify-center text-brand-orange shadow-sm">
                <SafeIcon icon={FiShield} className="w-8 h-8" />
              </div>
              <h2 className="text-3xl font-black text-brand-dark uppercase tracking-tight italic">{t.vision.privacyTitle}</h2>
            </div>
            <p className="text-gray-500 leading-relaxed font-bold italic text-xl">
              {t.vision.privacyText}
            </p>
          </div>

          <div className="bg-gray-50/50 p-16 rounded-[3rem] border border-gray-100 relative overflow-hidden group">
             <div className="absolute top-0 right-0 p-12 opacity-[0.03] group-hover:opacity-[0.08] transition-opacity">
              <SafeIcon icon={FiHeart} className="w-48 h-48" />
            </div>
            <div className="flex items-center gap-6 mb-10">
              <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center text-brand-orange shadow-sm border border-gray-100">
                <SafeIcon icon={FiHeart} className="w-8 h-8" />
              </div>
              <h2 className="text-3xl font-black text-brand-dark uppercase tracking-tight italic">{t.vision.talentTitle}</h2>
            </div>
            <p className="text-gray-500 leading-relaxed font-medium italic text-lg">
              {t.vision.talentText}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Visie;